import { memo } from 'react';

/**
 * Reusable Back to Login button component
 */
export const BackToLoginButton = memo(({ onClick, disabled = false, className = '' }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-solid font-['Roboto:Regular',sans-serif] font-normal leading-[normal] min-w-full relative shrink-0 text-[16px] md:text-[17px] lg:text-[18px] text-black underline w-[min-content] bg-transparent border-0 p-0 cursor-pointer text-left disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    style={{ fontVariationSettings: "'wdth' 100" }}
    type="button"
  >
    Back to Log In
  </button>
));

BackToLoginButton.displayName = 'BackToLoginButton';
